// constants of "irregular" symbols, emojis, hex codes, etc

export const DOT_SEPARATOR = '・';
